import React, { FC } from 'react';

import classNames from 'classnames';

import { EvPopup, IEvPopupProps } from '@evinced-private/ui-common';

import { SITE_SCANNER_APP_ID } from '../../../consts/dom-consts';

import './SiteScannerPopup.scss';

const SiteScannerPopup: FC<IEvPopupProps> = ({ className, ...props }) => {
	return (
		<EvPopup
			appElement={SITE_SCANNER_APP_ID}
			className={classNames('site-scanner-popup', className)}
			{...props}
		/>
	);
};

export { SiteScannerPopup };
